import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiService } from "./api.service";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class SettingLocationService {
  constructor(public apiService: ApiService) {}
  /**
   * Gets setting location service
   * @param params any
   * @returns any
   */
  get(params?: any) {
    return this.apiService.get(`${environment.apiLocation}/location-store`, params);
  }
  /**
   * Posts setting location service
   * @param params any
   * @returns any
   */
  post(params: any) {
    return this.apiService.post(`${environment.apiLocation}/location-store`, params);
  }
  /**
   * Deletes setting location service
   * @param locationStoreId number
   * @returns any
   */
  delete(params: any) {
    return this.apiService.put(`${environment.apiLocation}/location-store`, params);
  }
}
